<template>
  <div class="card">
    <Image v-if="content.image" :source="content.image" class="card__img" />
    <div class="card__content">
      <h3 v-if="content.name" class="h3 -bold">{{ content.name }}</h3>
      <h3 v-if="content.title" class="h3 break-space">{{ content.title }}</h3>
      <p class="paragraph mt-16">{{ content.description }}</p>
      <a v-if="content.link" :href="content.link" target="_blank" class="button mt-30">{{
        button || content.button
      }}</a>
    </div>
  </div>
</template>

<script>
import Image from '@/components/global/Image.vue'

export default {
  name: 'ActorCard',
  components: { Image },
  props: {
    button: {
      type: String,
      default: null,
    },
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
